import { render } from "./NewReceiverFinalPairing.vue?vue&type=template&id=b4b82286&scoped=true&ts=true"
import script from "./NewReceiverFinalPairing.vue?vue&type=script&lang=ts"
export * from "./NewReceiverFinalPairing.vue?vue&type=script&lang=ts"

import "./NewReceiverFinalPairing.vue?vue&type=style&index=0&id=b4b82286&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b82286"]])

export default __exports__